import angular from 'angular';
import _ from 'lodash';

angular.module('application').component('sidenav', {
    template: require('./sidenav.html'),
    controller: ["$state", "$mdSidenav", "$timeout", "appLoader", function ($state, $mdSidenav, $timeout, appLoader) {
        this.closeLeftMenu = function () {
            $mdSidenav('left').close();
        };

        this.goTo = function (destination) {
            this.closeLeftMenu();

            if ($state.current.name !== "app." + destination) {
                appLoader.show();
                $timeout(function () {
                    $state.go("app." + destination);
                });
            }
        };

        //Component Init
        this.$onInit = async () => {
            this.isSidenavOpen = false;
        };
    }]
});
